import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { facilityQueryKeys } from "./facilityQueryKeys";

export function useFacilityDisable({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (facilityId: number) => api.facilityApi.deactivate(facilityId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facilityQueryKeys.all() });
    },
  });
}
